<template>
  <tbody>
    <tr class="tr-row" :class="rowClasses" @click="toggle">
      <td class="tr-check" @click.stop>
        <label class="form-checkbox">
          <input type="checkbox" :checked="checked" :disabled="!selectable"
                 @change="$emit('check', $event.target.checked)">
          <i class="form-icon"></i>
        </label>
      </td>
      <td class="tr-num">{{ item.signedAt | date('DD/MM/YY HH:mm') }}</td>
      <td class="tr-name">{{ item.patient ? item.patient.name : '—' }}</td>
      <td>{{ item.expense ? item.expense.name : '—' }}</td>
      <td class="hide-sm">{{ insuranceName || '—' }}</td>
      <td class="text-right tr-num text-bold">{{ item.transfer | currency }}</td>
      <td>
        <status-pill :status="item.status"/>
        <span class="tr-sub" v-if="item.status === 'paid' && item.paidAt">
          {{ item.paidAt | date }}
        </span>
        <span class="tr-sub" v-else-if="item.status === 'consolidated' && document">
          {{ document }}
        </span>
      </td>
      <td class="text-right text-nowrap" @click.stop>
        <template v-if="item.status !== 'pending'">
          <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                  :data-tooltip="payTooltip" :disabled="!payable"
                  @click="$emit('pay', item)">
            <fa-icon :icon="['fal', 'hand-holding-usd']"/>
          </button>
          <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                  data-tooltip="Recibo do repasse" :disabled="!canPrint || !item.bundleId"
                  @click="$emit('print', item)">
            <fa-icon :icon="['fal', 'print']"/>
          </button>
        </template>
        <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
                data-tooltip="Abrir laudo" @click="$emit('open-report', item)">
          <fa-icon :icon="['fal', 'file-signature']"/>
        </button>
      </td>
    </tr>
    <tr class="tr-calc-wrap" v-if="expanded">
      <td colspan="8">
        <calc-detail :item="item"/>
      </td>
    </tr>
  </tbody>
</template>

<script>
import moment from 'moment';
import StatusPill from './StatusPill.vue';
import CalcDetail from './CalcDetail.vue';
import { isSelectable } from '../helpers';

export default {
  components: {
    StatusPill,
    CalcDetail,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    canPay: {
      type: Boolean,
      default: false,
    },
    canPrint: {
      type: Boolean,
      default: false,
    },
    document: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  computed: {
    selectable() {
      return isSelectable(this.item);
    },
    insuranceName() {
      return this.item.insurance ? this.item.insurance.customName || this.item.insurance.name : '';
    },
    rowClasses() {
      return {
        expanded: this.expanded,
        active: this.checked,
        paid: this.item.status === 'paid',
      };
    },
    payable() {
      return this.canPay && this.item.status !== 'paid' && !!this.item.financialId;
    },
    payTooltip() {
      if (this.item.status === 'paid') {
        return this.item.paidAt ? `Pago em ${moment(this.item.paidAt).format('L')}` : 'Pago';
      }
      return this.canPay ? 'Pagar' : 'Sem permissão para pagar';
    },
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
    },
  },
};
</script>
